var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "modal",
        {
          attrs: { title: "Confirm Production Task" },
          model: {
            value: _vm.openAcceptTask,
            callback: function($$v) {
              _vm.openAcceptTask = $$v
            },
            expression: "openAcceptTask"
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "media-content" }, [
              _c("div", { staticClass: "content" }, [
                _c("p", [
                  _c("strong", [
                    _vm._v("Would you like to Confirm this Production Task")
                  ]),
                  _c("br")
                ])
              ])
            ])
          ]),
          _c("isButton", {
            ref: "btnConfirm",
            attrs: {
              slot: "action",
              title: "Confirm",
              onClick: _vm.acceptTaskAction,
              state: "true"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Complete Production Task" },
          model: {
            value: _vm.openCompleteTask,
            callback: function($$v) {
              _vm.openCompleteTask = $$v
            },
            expression: "openCompleteTask"
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("div", { staticClass: "media-content" }, [
              _c("div", { staticClass: "content" }, [
                _c("p", [
                  _c("strong", [
                    _vm._v("Would you like to Complete this Production Task")
                  ]),
                  _c("br")
                ])
              ])
            ])
          ]),
          _c("isButton", {
            ref: "btnConfirmComplete",
            attrs: {
              slot: "action",
              title: "Confirm",
              onClick: _vm.acceptComplete,
              state: "true"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c(
        "modal",
        {
          attrs: { title: "Reject Task" },
          model: {
            value: _vm.openCancelTask,
            callback: function($$v) {
              _vm.openCancelTask = $$v
            },
            expression: "openCancelTask"
          }
        },
        [
          _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.rejectMessage,
                  expression: "rejectMessage"
                }
              ],
              staticClass: "input",
              attrs: { type: "text", placeholder: "Remark" },
              domProps: { value: _vm.rejectMessage },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.rejectMessage = $event.target.value
                }
              }
            })
          ]),
          _c("isButton", {
            ref: "btnReject",
            attrs: {
              slot: "action",
              onClick: _vm.rejectTask,
              state: "true",
              title: "Reject"
            },
            slot: "action"
          })
        ],
        1
      ),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-7" }, [
          _c(
            "h3",
            {
              staticClass: "title title-primary",
              staticStyle: { "margin-bottom": "0px" }
            },
            [_vm._v(_vm._s(_vm.taskData.prodTaskName))]
          ),
          _c(
            "nav",
            {
              staticClass: "breadcrumb",
              attrs: { "aria-label": "breadcrumbs" }
            },
            [
              _c("ul", [
                _vm._m(0),
                _vm._m(1),
                _c("li", [
                  _c(
                    "a",
                    { attrs: { href: "/project/" + _vm.taskData.projectID } },
                    [_vm._v(_vm._s(_vm.taskData.projectID))]
                  )
                ]),
                _c("li", { staticClass: "is-active" }, [
                  _c("a", { attrs: { href: "#", "aria-current": "page" } }, [
                    _vm._v(_vm._s(_vm.dataID))
                  ])
                ])
              ])
            ]
          )
        ]),
        _c("div", { staticClass: "column is-5" }, [
          _c(
            "div",
            { staticClass: "is-pulled-right" },
            [
              _vm.taskData.prodTaskStatus == "Accept" && _vm.isAdmin()
                ? _c(
                    "button",
                    {
                      staticClass: "button is-success",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          _vm.openAcceptTaskModal(
                            _vm.taskData.prodTaskID,
                            $event
                          )
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-check-square-o" }),
                      _vm._v("  Confirm Task\n          ")
                    ]
                  )
                : _vm._e(),
              _vm._v("\n           \n\n          "),
              _vm.taskData.prodTaskStatus === "Delivery" && _vm.isAdmin()
                ? [
                    _c("updateDeliveryDate", {
                      attrs: {
                        userData: _vm.tokenData,
                        projectInfo: _vm.taskData
                      }
                    }),
                    _c(
                      "button",
                      {
                        staticClass: "button is-success",
                        staticStyle: { "margin-right": "10px" },
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            _vm.openCompleteTaskModal(
                              _vm.taskData.prodTaskID,
                              $event
                            )
                          }
                        }
                      },
                      [
                        _c("i", { staticClass: "fa fa-checked" }),
                        _vm._v("  Complete Task\n          ")
                      ]
                    )
                  ]
                : _vm._e(),
              _vm.taskData.prodTaskStatus === "PO&Production" && _vm.isAdmin()
                ? [
                    _c("updateCurrentEst", {
                      attrs: {
                        userData: _vm.tokenData,
                        projectInfo: _vm.taskData
                      }
                    })
                  ]
                : _vm._e(),
              _vm.taskData.prodTaskStatus !== "Complete" &&
              _vm.taskData.prodTaskStatus !== "Delivery" &&
              _vm.isAdmin()
                ? _c(
                    "button",
                    {
                      staticClass: "button is-danger",
                      attrs: { href: "#" },
                      on: {
                        click: function($event) {
                          _vm.openCancelTaskModal(
                            _vm.taskData.prodTaskID,
                            $event
                          )
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-trash-o" }),
                      _vm._v("  Cancel Task\n          ")
                    ]
                  )
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _c(
        "tabs",
        [
          _c("tab", { attrs: { name: "Overview", selected: true } }, [
            _c("div", [
              _c("div", { staticClass: "columns is-desktop" }, [
                _c("div", { staticClass: "column  is-7" }, [
                  _c("div", { staticClass: "columns" }, [
                    _c(
                      "div",
                      { staticClass: "column is-gapless is-multiline" },
                      [
                        _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column" }, [
                            _c("div", { staticClass: "is-pulled-left" }, [
                              _c(
                                "h2",
                                {
                                  staticClass: "title is-4",
                                  staticStyle: { "margin-bottom": "1rem" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.taskData.prodTaskName) +
                                      "\n                          "
                                  ),
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "has-text-weight-light is-italic has-text-grey taskID"
                                    },
                                    [_vm._v(_vm._s(_vm.taskData.prodTaskID))]
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "field is-grouped is-grouped-multiline",
                                  staticStyle: { "margin-bottom": "0px" },
                                  attrs: { id: "meta" }
                                },
                                [
                                  _c("div", { staticClass: "control" }, [
                                    _c(
                                      "div",
                                      { staticClass: "tags has-addons" },
                                      [
                                        _c("span", { staticClass: "tag" }, [
                                          _vm._v("Status")
                                        ]),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "tag is-info",
                                            attrs: { href: "#colors" }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.taskData.prodTaskStatus
                                              )
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ])
                          ])
                        ]),
                        _c("task", { attrs: { task: _vm.taskData } })
                      ],
                      1
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "column" },
                  [
                    _c("chat-full", {
                      attrs: {
                        persons: _vm.personInChat,
                        type: "prodTask",
                        datas: _vm.messages,
                        roomName: _vm.dataID,
                        title: "Chat With Partner",
                        cls: "is-info"
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]),
          _c("tab", { attrs: { name: "PO", selected: false } }, [
            _vm.taskData.poName !== "" && _vm.taskData.poName !== null
              ? _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column" }, [
                    _c("h3", { staticClass: "title" }, [_vm._v("PO File")]),
                    _vm._v("\n            Download PO\n            "),
                    _c("i", { staticClass: "fa fa-download" }),
                    _vm._v(" \n            "),
                    _c(
                      "a",
                      {
                        attrs: {
                          target: "_blank",
                          href:
                            "https://api.musubi-thai.com/public/" +
                            _vm.taskData.poPath +
                            _vm.taskData.poName
                        }
                      },
                      [_vm._v(_vm._s(_vm.taskData.poOrgName))]
                    )
                  ])
                ])
              : _vm._e(),
            _vm.isAdmin()
              ? _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "article",
                      { staticClass: "box-section" },
                      [
                        _c(
                          "div",
                          { staticClass: "message-section is-clearfix" },
                          [_c("p", [_vm._v("Upload PO")])]
                        ),
                        _c("upload", {
                          ref: "upload",
                          attrs: { isMultiple: false }
                        })
                      ],
                      1
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button is-success",
                        attrs: { type: "button" },
                        on: { click: _vm.uploadPO }
                      },
                      [
                        _c("i", { staticClass: "fa fa-upload" }),
                        _vm._v("  Upload PO")
                      ]
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _c(
            "tab",
            { attrs: { name: "Files" } },
            [
              _c("componentRelatedFile", {
                attrs: { data: _vm.taskData.task_attach_files }
              })
            ],
            1
          ),
          _c(
            "tab",
            { attrs: { name: "Quotation History" } },
            [
              _c("quHistory", { attrs: { history: _vm.taskData.prodtask_qus } })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/admin/dashboard/" } }, [_vm._v("Dashboard")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("a", { attrs: { href: "/admin/project/" } }, [_vm._v("All Project")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28490ac0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28490ac0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/tasks/view/_id.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-28490ac0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/project/tasks/view/_id.vue
// module chunks = 3